import client from './without-auth-api-client'

export const getBuilder = (id) => {
    return client.get(`/system/builder/${id}`)
}

export const getMobileBuilder = () => {
  return client.get(`/system/get-builder?for=mobile`);
}
